import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.less']
})
export class LandingComponent implements OnInit {

  currUser;
  constructor(private router: Router) { }
 
  ngOnInit() {
    this.currUser = JSON.parse(localStorage.getItem('user'));
    if (!this.currUser.gopherAdmin) {
      this.router.navigate(['home']);
    }
  }

}
